(function(){
  var HOLIDAYS=['2026-01-01','2026-01-12','2026-02-11','2026-02-23','2026-03-20','2026-04-29','2026-05-03','2026-05-04','2026-05-05','2026-05-06','2026-07-20','2026-08-11','2026-09-21','2026-09-22','2026-09-23','2026-10-12','2026-11-03','2026-11-23','2026-12-23','2027-01-01','2027-01-11','2027-02-11','2027-02-23','2027-03-22','2027-04-29','2027-05-03','2027-05-04','2027-05-05','2027-07-19','2027-08-11','2027-09-20','2027-09-23','2027-10-11','2027-11-03','2027-11-23'];
  function isBiz(d){var w=d.getDay();if(w===0||w===6)return false;var s=d.toISOString().slice(0,10);return HOLIDAYS.indexOf(s)===-1;}
  function addBizDays(start,n){var d=new Date(start);var c=0;while(c<n){d.setDate(d.getDate()+1);if(isBiz(d))c++;}return d;}
  function period(d){var day=d.getDate();return day<=10?'上旬':day<=20?'中旬':'下旬';}
  function calc(n){
    n=n||70;
    var today=new Date();today.setHours(0,0,0,0);
    var del=addBizDays(today,n);
    var iso=del.getFullYear()+'-'+String(del.getMonth()+1).padStart(2,'0')+'-'+String(del.getDate()).padStart(2,'0');
    var label=(del.getMonth()+1)+'月'+period(del);
    return{iso:iso,label:label};
  }
  window.KobeDelivery=calc;

  // 納期(_delivery_date)のカートattributesセットは、シミュレーターの addToCart 内
  // /cart/update.js（本命）で実施している。以前ここにあった「fetch横取り」と
  // 「button[name=add]クリック2秒後バックアップ」は /cart/update.js の二重・三重
  // 発火になり、カート追加のラグと無駄な往復の一因だったため撤去。

  document.addEventListener('DOMContentLoaded',function(){
    var el=document.getElementById('delivery-date-block');
    if(!el)return;
    var days=parseInt(el.getAttribute('data-days'),10)||70;
    var r=calc(days);
    window.__deliveryDateISO=r.iso;
    window.__deliveryDateLabel=r.label;
    el.innerHTML='<div style="background:#f8f9fa;padding:12px 14px;margin:12px 0;border-radius:8px;border-left:4px solid #2563eb;font-family:inherit;">'
      +'<div style="font-size:13px;font-weight:600;">📦 今ご注文いただくと'+r.label+'までにお届けします</div>'
      +'<div style="font-size:11px;color:#666;margin-top:4px;">※製作状況により、早くお届けできる場合があります</div>'
      +'</div>';
  });
})();
